if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        this.cart = document.querySelector("cart-drawer");
        this.hideErrors = this.dataset.hideErrors === "true";
        this.enableFreeGiftLogic = this.dataset.enableFreeGiftLogic === "true";
        this.enableFreeGiftMetafield =
          this.dataset.enableFreeGiftMetafield === "true";
        this.freeGiftVariantId = this.dataset.freeGiftVariantId;
        this.freeGiftProductId = this.dataset.freeGiftProductId;
      }

      shouldAddFreeGift(formData) {
        if (!this.enableFreeGiftLogic || !this.enableFreeGiftMetafield) return false;
        if (!this.freeGiftVariantId || !this.freeGiftProductId) return false;

        const productIdInput = this.form.querySelector(
          '[name="product-id"], [data-product-id-input]',
        );
        const currentProductId = productIdInput?.value || this.dataset.productId;

        // Prevent auto-adding the same product as its own gift line.
        if (
          currentProductId &&
          String(currentProductId) === String(this.freeGiftProductId)
        ) {
          return false;
        }

        const currentVariantId = formData.get("id");
        if (String(currentVariantId) === String(this.freeGiftVariantId)) {
          return false;
        }

        return true;
      }

      addFreeGiftToCart(formData) {
        const giftFormData = new FormData();
        giftFormData.append("id", this.freeGiftVariantId);
        giftFormData.append("quantity", formData.get("quantity") || "1");

        if (this.cart) {
          giftFormData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          giftFormData.append("sections_url", window.location.pathname);
        }

        const giftConfig = fetchConfig("javascript");
        giftConfig.headers["X-Requested-With"] = "XMLHttpRequest";
        delete giftConfig.headers["Content-Type"];
        giftConfig.body = giftFormData;

        return fetch(`${routes.cart_add_url}`, giftConfig).then((response) =>
          response.json(),
        );
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        this.handleErrorMessage();

        /* Clamp quantity to max before submitting */
        const qtyInput = this.form.querySelector('input[name="quantity"]');
        if (qtyInput) {
          const max = parseInt(qtyInput.getAttribute("max"), 10);
          const min = parseInt(qtyInput.getAttribute("min"), 10) || 1;
          let val = parseInt(qtyInput.value, 10);
          if (isNaN(val) || val < min) val = min;
          else if (!isNaN(max) && val > max) val = max;
          qtyInput.value = val;
        }

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".spinner-loading-btn")?.classList.remove("hidden");
        this.submitButton
          .querySelector("[data-addtocart-text]")
          .classList.add("hidden");
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
        }
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.submitButton.setAttribute("aria-disabled", true);
              this.error = true;
              fetch(
                `${routes.cart_url}?sections=` +
                  this.cart
                    .getSectionsToRender()
                    .map((section) => section.id)
                    .toString(),
              )
                .then((response) => response.json())
                .then((response) => {
                  let parsedState = {};
                  parsedState["sections"] = response;
                  this.cart.renderContents(parsedState);
                });
              this.resetButton();
              return;
            } else if (!this.cart) {
              if (this.shouldAddFreeGift(formData)) {
                return this.addFreeGiftToCart(formData)
                  .catch(() => null)
                  .then(() => {
                    window.location = window.routes.cart_url;
                  });
              }
              window.location = window.routes.cart_url;
              return;
            }
            this.error = false;

            const finalizeCartUi = (cartResponse) => {
              if (document.querySelector(".product-cart-sticky")) {
                document
                  .querySelector(".product-cart-sticky")
                  .classList.remove("active");
                document
                  .querySelector(
                    ".product-cart-sticky .product-cart-sticky-detail",
                  )
                  .classList.remove("active");
              }
              this.cart.renderContents(cartResponse);
              this.cart.classList.add("open");
              document.querySelector("body").classList.add("no-scroll");
            };

            if (this.shouldAddFreeGift(formData)) {
              return this.addFreeGiftToCart(formData)
                .then((giftResponse) => {
                  if (giftResponse && !giftResponse.status) {
                    finalizeCartUi(giftResponse);
                  } else {
                    finalizeCartUi(response);
                  }

                  return fetch(window.routes.cart_url + ".js")
                    .then(function (r) {
                      return r.json();
                    })
                    .then((cartData) => {
                      publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: "product-form",
                        productVariantId: formData.get("id"),
                        cartState: cartData,
                      });
                      this.resetButton();
                    })
                    .catch(() => {
                      publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: "product-form",
                        productVariantId: formData.get("id"),
                      });
                      this.resetButton();
                    });
                })
                .catch(() => {
                  finalizeCartUi(response);
                  return fetch(window.routes.cart_url + ".js")
                    .then(function (r) {
                      return r.json();
                    })
                    .then((cartData) => {
                      publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: "product-form",
                        productVariantId: formData.get("id"),
                        cartState: cartData,
                      });
                      this.resetButton();
                    })
                    .catch(() => {
                      publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: "product-form",
                        productVariantId: formData.get("id"),
                      });
                      this.resetButton();
                    });
                });
            }

            finalizeCartUi(response);
            /* Fetch cart state, update max, then re-enable button */
            return fetch(window.routes.cart_url + ".js")
              .then(function (r) {
                return r.json();
              })
              .then((cartData) => {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  cartState: cartData,
                });
                this.resetButton();
              })
              .catch(() => {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                });
                this.resetButton();
              });
          })
          .catch((e) => {
            console.error(e);
            this.resetButton();
          });
      }

      resetButton() {
        this.submitButton.classList.remove("loading");
        this.submitButton
          .querySelector("[data-addtocart-text]")
          .classList.remove("hidden");
        if (this.cart && this.cart.classList.contains("is-empty"))
          this.cart.classList.remove("is-empty");
        this.submitButton.removeAttribute("aria-disabled");
        this.querySelector(".spinner-loading-btn")?.classList.add("hidden");
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}

document.addEventListener("change", (event) => {
  const variantSelect = event.target;
  if (!(variantSelect instanceof HTMLSelectElement)) return;
  if (variantSelect.id !== "drawer-free-gift-variant") return;

  const selectedOption = variantSelect.options[variantSelect.selectedIndex];
  const variantImage = selectedOption?.dataset?.variantImage;
  if (!variantImage) return;

  const upsellCard = variantSelect.closest(".free-gift-upsell-card");
  const imageElement = upsellCard?.querySelector(".free-gift-upsell-image");
  if (!imageElement) return;

  imageElement.src = variantImage;
  imageElement.srcset = "";
});
